import { createContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  setToLocalStorage,
  removeFromLocalStorage,
  clearLocalStorage,
} from "../../lib/localStorage";
const GuiContext = createContext();

export function GuiContextProvider({ children }) {
  const navigate = useNavigate();
  const initialState = JSON.parse(localStorage.getItem("userData")) || {};
  const selectedInitalState = JSON.parse(localStorage.getItem("selected")) || {
    selectedServer: "",
    selectedAccount: "",
  };

  const [userData, setUserData] = useState(initialState);
  const [selected, setSelected] = useState(selectedInitalState);
  const initialCompositionState = JSON.parse(
    localStorage.getItem("compositionsContext")
  );
  const [compositionsContext, setCompositonsContext] = useState(
    initialCompositionState
  );

  const selectedAccount = (account) => {
    setCompositonsContext(null);
    const newSelected = { ...selected, selectedAccount: account };
    setSelected(newSelected);
    setToLocalStorage("selected", newSelected);
  };
  const selectedServer = (server) => {
    setCompositonsContext(null);
    const newSelected = { ...selected, selectedServer: server };
    setSelected(newSelected);
    setToLocalStorage("selected", newSelected);
  };

  const changeUserData = (data) => {
    setToLocalStorage("userData", data);
    setUserData(data);
    const initialSelected = {
      selectedServer: data.servers[0],
      selectedAccount: data.accounts[0],
    };
    setSelected(initialSelected);
    setToLocalStorage("selected", initialSelected);
  };
  const updateVersion = (newVersion) => {
    setUserData((prev) => ({ ...prev, version: newVersion }));
    setToLocalStorage("userData", { ...userData, version: newVersion });
  };
  const updateAccounts = (newAccount) => {
    const newAccounts = [...userData.accounts, newAccount];
    const newUserData = { ...userData, accounts: newAccounts };
    setToLocalStorage("userData", newUserData);
    setUserData(newUserData);
  };
  const removeAccount = (accountToRemove) => {
    const filteredAccounts = userData.accounts.filter(
      (account) => account !== accountToRemove
    );
    selectedAccount(filteredAccounts[0]);
    const newUserData = { ...userData, accounts: filteredAccounts };
    setToLocalStorage("userData", newUserData);
    setUserData(newUserData);
  };
  const updateServers = (newServer) => {
    const newServers = [...userData.servers, newServer];
    const newUserData = { ...userData, servers: newServers };
    setToLocalStorage("userData", newUserData);
    setUserData(newUserData);
  };
  const removeServer = (serverToRemove) => {
    const filteredServers = userData.servers.filter(
      (server) => server !== serverToRemove
    );
    selectedServer(filteredServers[0]);
    const newUserData = { ...userData, servers: filteredServers };
    setToLocalStorage("userData", newUserData);
    setUserData(newUserData);
  };

  const removeTable = (tableToRemove) => {
    try {
      const filteredTables = compositionsContext.compositions.filter(
        (composition) => composition !== tableToRemove
      );
      const newContextData = {
        ...compositionsContext,
        compositions: filteredTables,
      };
      setToLocalStorage("compositionsContext", [newContextData]);
      setCompositonsContext(newContextData);
    } catch (error) {
      console.error(error);
    }
  };
  const logOut = () => {
    setUserData({});
    setCompositonsContext(null);
    clearLocalStorage();
    // removeFromLocalStorage("userData");
    // removeFromLocalStorage("selected");
    // removeFromLocalStorage("compositionsContext");
    // removeFromLocalStorage("tableStructure");
    // removeFromLocalStorage("activeComposition");
    // removeFromLocalStorage("activePlugins");
    // removeFromLocalStorage("pKey");
    navigate("/login");
    window.location.reload();
  };
  const handleComposition = (e) => {
    if (!e) return;
    setCompositonsContext(e);
    setToLocalStorage("compositionsContext", e);
  };
  const resetCompositions = () => {
    setCompositonsContext({});
    removeFromLocalStorage("compositionsContext");
  };
  const valueToShare = {
    //ovo radi ovako kada se podigne build na serveru
    URL: process.env.REACT_APP_API_URL || window.location.origin,
    changeUserData: changeUserData,
    updateAccounts: updateAccounts,
    removeAccount: removeAccount,
    updateServers: updateServers,
    removeServer: removeServer,
    logOut: logOut,
    userData: userData,
    selected: selected,
    removeTable: removeTable,
    selectedAccount: selectedAccount,
    selectedServer: selectedServer,
    handleComposition: handleComposition,
    updateVersion: updateVersion,
    compositionsContext: compositionsContext,
    resetCompositions: resetCompositions,
  };

  return (
    <GuiContext.Provider value={valueToShare}>{children}</GuiContext.Provider>
  );
}

export default GuiContext;
